"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _meterReadingFormHelper = require("../../Anonym/MeterReadingForm/meterReadingFormHelper");
var MeterRegisterLabel = function MeterRegisterLabel(props) {
  var deviceData = props.deviceData,
    register = props.register,
    iteration = props.iteration,
    classNames = props.classNames,
    loggedIn = props.loggedIn,
    _props$headerType = props.headerType,
    headerType = _props$headerType === void 0 ? 'h5' : _props$headerType;
  var registerType = register.registerType && register.registerType !== '' ? " (".concat(register.registerType, ")") : '';
  var HeaderType = headerType;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row",
    key: iteration
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classNames || ''
  }, /*#__PURE__*/_react.default.createElement(HeaderType, {
    className: loggedIn ? 'loggedin-meter-form__header loggedin-meter-form__header--additional-padding' : 'ano-meter-form__header ano-meter-form__header--additional-padding'
  }, deviceData.division !== 'GAS' && /*#__PURE__*/_react.default.createElement("span", {
    "data-qa": "checkSpan"
  }, "".concat((0, _meterReadingFormHelper.getObisLabel)(register.registerTypeLabel, props), " ").concat((0, _meterReadingFormHelper.formatObis)(register.obis)).concat(registerType)))));
};
var _default = exports.default = MeterRegisterLabel;